<div class="progress-bar">
  <app-question-number [value]="activeQuestionNr + 1"></app-question-number>
  <app-progress-bar [active]="activeQuestionNr" [values]="progressBarData"></app-progress-bar>
</div>

<div class="questionText"><span>{{questionText}}</span></div>

<div class="answers-results" [ngClass]="{'results':showResults, 'invisible':hideOptions}">
  <img class="divider" src="/img/games/questions/lijnen.svg" width="100%">

  <div *ngFor="let option of options" class="answers-result-button answer raised"
    [ngClass]="
      { 'good' : showResults && option.correct === true,
        'inactive': option.correct !== true,
        'disabled' : disableOptions
      }"
    (click)="selectAnswer(option); audio.playSoundClick();">
    <span>{{option.title}}</span>
  </div>

  <span *ngIf="options.length===0" class="answers-result-button answer raised" (click)="setNextQuestion()">[next]</span>

  <img src="/img/games/spiegel.png" style="width:11em" *ngIf="showMirror">
  <h3 class="mirrorText" *ngIf="showMirror" [ngClass]="{'invisible':!showMirrorText}">{{mirrorText}}</h3>
  <img class="divider" src="/img/games/questions/lijnen.svg" width="100%">
</div>

<div class="next-wrap">
  <div class="footnote" [ngClass]="{'invisible':!showResults}">
    <span>{{feedbackText}}</span>
  </div>

  <app-button-next2 [disabled]="!enableNext" (click)="setNextQuestion(); audio.playSoundClick();"></app-button-next2>
  <!-- <span [ngClass]="{'disabled':!enableNext}" class="button green raised" (click)="setNextQuestion(); audio.playSoundClick();">{{buttonCaption}}</span> -->
</div>
